export default "__VITE_ASSET__DH9OVoWe__"